import {
    call,
    put,
    select
} from 'redux-saga/effects';

import {
    saveRouteInfo
} from '../../../core/js/actions/initialActions';
import {
    receiveCategoryItems,
    requestCategoryItems
} from '../actions/requestActions';
import {
    getCategoryOrchestration
} from '../../../core/js/utils/apiRoutes';
import {
    getRouteInfo
} from '../utils/utils';
import {
    initializeDynamicYieldSaga,
    initializeRRSaga
} from '../../../core/js/sagas/recommendationsSagas';
import {
    initialSaga
} from '../../../core/js/sagas/initialSagas';
import {
    debug
} from '../../../core/js/utils/logger';
import {
    randomizeFooterPromoSaga
} from '../../../core/js/sagas/promoSagas';
import rrUtils from '../../../core/js/utils/rrUtils';
import { tryCatchSaga } from '../../../core/js/sagas/tryCatchSagas';
import { siteMessageSaga } from '../../../core/js/sagas/siteMessageSagas';

export function* categoryRichRelevanceSaga() {
    const state = yield select();

    let rrPlacementId = null;
    let dyPlacementIds = null;
    let rrTileTemplate = 'TITLE_ONLY';
    let dyPlacementTileCount;

    let tileCount = _.get(state.core, 'constants.tileOptions.deafult_rr_tile_count');

    if (state.category.landingPage) {
        // data attribute value populated by rendered Contentful entry
        const placementData = rrUtils.getRichRelevancePlacementData();
        rrPlacementId = placementData.rrPlacementId;
        dyPlacementIds = placementData.dyPlacementIds;
        dyPlacementTileCount = placementData.dyPlacementTileCount;
    } else if (!_.get(state.category, 'products.totalRecordCount') || state.category.products.totalRecordCount <= 0) {
        dyPlacementIds = [_.get(state,
                              'core.constants.thirdParty.default.dynamic_yield.placement_ids.searchNoResults')];

        // Display Tile and Price for No Search Results
        // Get tileType from settings, else global rrRecs config, else fall back to TITLE_ONLY
        rrTileTemplate = rrUtils.getRRTileTemplate(state, 'constants.tileOptions.rr_no_search_results_tile_template');
    }

    if (rrPlacementId) {
        yield call(initializeRRSaga, rrPlacementId, tileCount, rrTileTemplate);
    }

    if (dyPlacementIds && dyPlacementIds.length > 0) {
        for (const dyPlacementId of dyPlacementIds) {
            tileCount = _.get(dyPlacementTileCount, `${dyPlacementId}`, tileCount);
            yield call(initializeDynamicYieldSaga, dyPlacementId, tileCount, rrTileTemplate);
        }
    }
}

export function* requestSuccessSaga(response, route, options) {
    yield put(receiveCategoryItems(
        response,
        options.categoryId,
        options.searchTerm,
        options.requestedPage,
        response.category.sortOptions,
        options.qs
    ));

    if (options.pushState) {
        const currentQueryString = _.get(response, 'category.pageOptions.currentPage.queryString');
        const queryStringWithQuestionMark = currentQueryString ? `?${currentQueryString}` : '';
        const category = _.pick(response.category, ['categorySlug', 'pageOptions']);

        history.pushState({ category: category }, '',
                          `${response.category.catalogRequestPathname}${queryStringWithQuestionMark}`);
    }
    yield call(randomizeFooterPromoSaga);
    yield call(categoryRichRelevanceSaga);

    // since this saga is called from a detached task (use of spawn in tryCatchSaga), send custom event to notify when
    // we have received new category items
    $.event.trigger({
        type: 'RECEIVED_CATEGORY_ITEMS',
        payload: {
            context: _.get(options, 'meta.context', null)
        }
    });
}

export function* requestFailSaga(error, route, options) {
    const state = yield select();

    Raven.captureException(error, {
        extra: {
            route: route
        }
    });
    const message = 'Something was wrong with your request';

    options.meta.component.afterRender({ state: state });
    yield call(siteMessageSaga, message, route, error);
}

export function* beginRequestSaga(requestedPage,
                                  requestType,
                                  categoryId = null,
                                  searchTerm = null,
                                  qs = null,
                                  pushState = true,
                                  meta) {
    yield put(requestCategoryItems(requestType));

    const state = yield select();
    const categoryContext = _.get(state, 'category.context');
    const route = getCategoryOrchestration(state, categoryId, categoryContext, searchTerm, requestedPage, qs);

    const requestOptions = {
        successSaga: requestSuccessSaga,
        failSaga: requestFailSaga,
        categoryId: categoryId,
        searchTerm: searchTerm,
        requestedPage: requestedPage,
        qs: qs,
        meta: meta,
        pushState: pushState
    };

    yield call(tryCatchSaga, route, requestOptions);
}

export function* categoryInitialSaga() {
    yield call(initialSaga);
    debug('Router initialized');

    const state = yield select();

    yield put(saveRouteInfo(getRouteInfo(state)));
    debug('Route info saved');

    yield call(categoryRichRelevanceSaga);
}

export default [
    categoryInitialSaga
];
